const cards = [
  {
    image: 'https://readdy.ai/api/search-image?query=Behind%20the%20scenes%20of%20a%20television%20drama%20production%20with%20cameras%20and%20lighting%20rigs%2C%20warm%20atmospheric%20lighting%2C%20professional%20film%20set%2C%20soft%20coral%20and%20golden%20tones%2C%20cinematic%20composition&width=600&height=400&seq=card-01&orientation=landscape',
    tag: '深度追踪',
    title: '从顶流到争议：一位明星的舆论沉浮全记录',
    summary: '三年时间，从万人追捧到争议缠身，这位曾经的顶流经历了怎样的舆论风暴？我们梳理了完整时间线。',
    author: '吃瓜编辑部',
    date: '3天前',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Music%20award%20ceremony%20stage%20with%20golden%20trophies%20and%20spotlights%2C%20elegant%20performance%20venue%2C%20warm%20amber%20lighting%2C%20glamorous%20entertainment%20industry%20event%2C%20professional%20photography%20angles&width=600&height=400&seq=card-02&orientation=landscape',
    tag: '年度盘点',
    title: '2026年上半年娱乐圈十大名场面大盘点',
    summary: '从颁奖典礼的高光时刻到综艺节目的意外瞬间，今年上半年娱乐圈贡献了太多值得回味的经典画面。',
    author: '瓜田观察员',
    date: '5天前',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Fashion%20runway%20event%20with%20models%20and%20designer%20clothing%2C%20sophisticated%20lighting%20design%2C%20warm%20neutral%20palette%20with%20coral%20accents%2C%20professional%20fashion%20photography%20style%2C%20elegant%20atmosphere&width=600&height=400&seq=card-03&orientation=landscape',
    tag: '行业观察',
    title: '娱乐圈"CP营销"产业链深度揭秘',
    summary: '从荧幕情侣到真人CP，娱乐圈的CP营销已形成完整的商业闭环。背后运作机制和资本逻辑一探究竟。',
    author: '深度瓜田',
    date: '1周前',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Streaming%20platform%20content%20display%20with%20multiple%20show%20posters%2C%20digital%20entertainment%20concept%2C%20warm%20modern%20interface%20design%2C%20soft%20coral%20and%20cream%20color%20scheme%2C%20clean%20minimalist%20arrangement&width=600&height=400&seq=card-04&orientation=landscape',
    tag: '数据报告',
    title: '暑期档综艺大战：各家平台王牌节目收视分析',
    summary: '各大视频平台暑期综艺矩阵全面开战，数据背后折射出怎样的行业趋势和观众口味变迁？',
    author: '数据挖瓜',
    date: '1周前',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Social%20media%20influencer%20content%20creation%20workspace%20with%20ring%20light%20and%20camera%20setup%2C%20modern%20creator%20studio%2C%20warm%20ambient%20lighting%2C%20professional%20equipment%2C%20soft%20coral%20and%20cream%20tones&width=600&height=400&seq=card-05&orientation=landscape',
    tag: '人物特写',
    title: '从素人到千万粉：一位网红的内容创业之路',
    summary: '三年时间从零到千万粉丝，这位90后网红经历了怎样的蜕变？独家对话揭秘背后的故事与思考。',
    author: '人物瓜田',
    date: '2周前',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Film%20editing%20suite%20with%20professional%20monitors%20and%20timeline%20display%2C%20creative%20post%20production%20environment%2C%20warm%20studio%20lighting%2C%20modern%20workspace%20design%2C%20soft%20golden%20and%20cream%20color%20palette&width=600&height=400&seq=card-06&orientation=landscape',
    tag: '幕后故事',
    title: '一部热播剧的诞生：从剧本到荧幕的全流程揭秘',
    summary: '热播剧《XX》背后的制作故事，编剧、导演、演员三方视角还原创作过程中的酸甜苦辣。',
    author: '幕后瓜田',
    date: '2周前',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Concert%20tour%20preparation%20backstage%20with%20instruments%20and%20equipment%20cases%2C%20professional%20music%20production%20environment%2C%20warm%20theatrical%20lighting%2C%20soft%20coral%20and%20amber%20tones%2C%20creative%20atmosphere&width=600&height=400&seq=card-07&orientation=landscape',
    tag: '行业趋势',
    title: '音乐演出市场爆发：线下演唱会经济全面复苏',
    summary: '2026年演唱会市场迎来井喷式增长，各大城市排期已满至年底。演出经济的背后有哪些新趋势？',
    author: '行业瓜田',
    date: '3周前',
  },
];

export default function CardsSection() {
  return (
    <section
      id="cards"
      className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-100"
      style={{ scrollMarginTop: '80px' }}
    >
      <div className="w-full max-w-7xl mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            深度追踪
          </h2>
          <p className="mt-2 text-sm md:text-base text-foreground-600">
            精选长文，带你看懂娱乐圈
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {cards.map((item, i) => (
            <article
              key={i}
              className={`group flex flex-col rounded-lg bg-background-50 border border-background-200/70 overflow-hidden transition-colors duration-200 hover:border-primary-200 ${
                i === 0 ? 'lg:col-span-2 lg:flex-row' : ''
              }`}
            >
              {/* Image */}
              <div className={`relative overflow-hidden ${i === 0 ? 'lg:w-1/2' : 'w-full'} aspect-[3/2] lg:aspect-auto`}>
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
                  loading="lazy"
                  onError={(e) => {
                    (e.currentTarget.parentElement as HTMLElement).style.display = 'none';
                  }}
                />
                <span className="absolute top-2 left-2 text-xs px-2 py-0.5 rounded-full bg-primary-500 text-background-50 whitespace-nowrap">
                  {item.tag}
                </span>
              </div>

              {/* Content */}
              <div className={`flex flex-col gap-1.5 p-4 md:p-5 ${i === 0 ? 'lg:w-1/2' : ''}`}>
                <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-900 leading-snug line-clamp-2">
                  {item.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed line-clamp-2 flex-1">
                  {item.summary}
                </p>
                <div className="flex items-center gap-3 text-xs text-foreground-500 mt-1">
                  <span>{item.author}</span>
                  <span>·</span>
                  <span>{item.date}</span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}